import { render } from "./yuZhiPrintModel.vue?vue&type=template&id=2b73330b"
import script from "./yuZhiPrintModel.vue?vue&type=script&lang=js"
export * from "./yuZhiPrintModel.vue?vue&type=script&lang=js"

import "./yuZhiPrintModel.vue?vue&type=style&index=0&id=2b73330b&lang=scss"

import exportComponent from "D:\\companyProject\\G10Product\\trunk\\Bestech.CloudPos\\Bestech.CloudPos.Portal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__